export const notificationId = {
  185: {
    blockClassName:
      "alert alert-dismissible fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Important",
  },
  180: {
    blockClassName:
      "alert alert-dismissible fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Important",
  },
  184: {
    blockClassName:
      "alert alert-dismissible fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Important",
  },
  150: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-setting text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_CHANGE_SETTING",
  },
  127: {
    type1: {
      blockClassName:
        "alert alert-dismissible alert-danger border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
      iconClassName: "icon-monitor text-danger fs-5",
      alertName: "PARENT_NOTIFICATION_WEBSITE_ALERT",
    },
    type2: {
      blockClassName:
        "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
      iconClassName: "icon-mobile-one text-danger fs-5",
      alertName: "PARENT_NOTIFICATION_APPLICATION_ALERT",
      alertText: "",
    },
  },
  149: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Task completed by kid",
  },
  136: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-mobile-one text-warning fs-5",
    alertName: "Application alert",
  },
  122: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Blocked website open",
  },
  137: {
    blockClassName:
      "alert alert-dismissible alert-danger border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_WEBSITE_ALERT",
  },
  123: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Warned webiste open which are done from categories",
  },
  119: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-connect text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_APP_OPEN_REQUEST",
  },
  94: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-connect text-success fs-5",
    alertName: "Approve blocked app request",
  },
  93: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName: "Rejected blocked app request",
  },
  120: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-connect text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_WEBSITE_OPEN_REQUEST",
    alertText: "",
  },
  95: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-connect text-success fs-5",
    alertName: "Approve blocked web request",
  },
  96: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName: "Rejected blocked web request",
  },
  148: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-connect text-success fs-5",
    alertName: "PARENT_NOTIFICATION_TIME_EXTENSION_REQUEST_RECEIVED",
    alertText: "PARENT_NOTIFICATION_TIME_EXTENSION_REQUEST_CHILD_NAME_DEVICE",
  },
  143: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-connect text-success fs-5",
    alertName: "Approve time extension request",
  },
  144: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName: "Reject time extension request",
  },
  154: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName: "Bad word tapped",
  },
  155: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-triangle text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_BAD_WORD_SEARCH",
    alertText: "",
  },
  165: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-key text-blue-800 fs-5",
    alertName: "PARENT_NOTIFICATION_SEARCH_A_KEYWORD",
    alertText: "",
  },
  166: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-location text-warning fs-5",
    alertName: "PARENT_NOTIFICATION_PICK_ME_UP_TITLE",
    alertText: "",
  },
  131: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-key text-blue-800 fs-5",
    alertName: "PARENT_NOTIFICATION_VIDEO_KEYWORD_OPEN",
  },
  153: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Nudity content detected on childs device",
  },
  125: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-timer-add text-blue-800 fs-5",
    alertName: "Device use over time daily limit end",
  },
  124: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-timer-add text-blue-800 fs-5",
    alertName: "Device use over time slot end",
  },
  126: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-timer-add text-warning fs-5",
    alertName: "PARENT_NOTIFICATION_ATTEMPT_OUT_OF_USE",
    alertText: "",
  },
  140: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName: "PERMISSIONS_DISPLAY_OVER_OTHER_APPS",
    alertText: "",
  },
  112: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "SOS alert received",
  },
  201: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Kid sent you a message",
  },
  202: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Parent sent you a message",
  },
  128: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info text-pink-800 fs-5",
    alertName: "Stop kido protect",
  },
  129: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-check-round text-warning fs-5",
    alertName: "PARENT_NOTIFICATION_NEW_APP_INSTALLED",
    alertText: "",
  },
  141: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-monitor text-danger fs-5",
    alertName:
      "PARENT_NOTIFICATION_NEW_BROWSER_APP_INSTALLED_THAT_CANNOT_BE_MONITORED_TITLE",
    alertText:
      "PARENT_NOTIFICATION_NEW_BROWSER_INSTALLED_THAT_CANNOT_BE_MONITORED_DESCRIPTION",
  },
  142: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-mobile-one text-danger fs-5",
    alertName:
      "PARENT_NOTIFICATION_NEW_INSTALL_APP_THAT_BLOCKS_KIDO_PROTECT_APP_TITLE",
    alertText:
      "PARENT_NOTIFICATION_NEW_APP_INSTALLED_THAT_BLOCKS_KP_APP_DESCRIPTION",
  },
  152: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Install new app",
  },
  132: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Left Allowed area",
  },
  133: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-3",
    iconClassName: "icon-location text-warning fs-5",
    alertName: "PARENT_NOTIFICATION_RETURN_ALLOW_AREA",
    alertText: "",
  },
  163: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-location text-warning fs-5",
    alertName: "GPS disabled",
  },
  164: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-brain-coding text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_DEVELOPER_MODE_IS_ENABLED",
    alertText: "",
  },
  134: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-battery-low text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_BATTERY_ALERT",
    alertText: "",
  },
  151: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Did not complete task",
  },
  149: {
    blockClassName:
      "alert alert-dismissible bg-blue-50 border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-tasks text-blue-400 fs-5",
    alertName: "PARENT_NOTIFICATION_TASK_COMPLETED",
    alertText: "",
  },
  145: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "Task created",
  },
  156: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "sent a sms",
  },
  157: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "receive a sms",
  },
  158: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "called a number",
  },
  159: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "receive a call",
  },
  2: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-comment-one text-warning-300 fs-5",
    alertName: "New message received",
  },
  181: {
    blockClassName:
      "alert alert-dismissible border fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "ALERT_NOTIFICATION",
    alertText: "",
  },
  71: {
    blockClassName:
      "alert alert-dismissible alert-warning fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-octagon text-blue-800 fs-5",
    alertName: "PARENT_NOTIFICATION_MANUAL_SCREENSHOT_CAPTURED_TITLE",
    alertText: "PARENT_NOTIFICATION_MANUAL_SCREENSHOT_CAPTURED_DESCRIPTION",
  },
  178: {
    blockClassName:
      "alert alert-dismissible alert-success fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "",
    alertName: "PARENT_NOTIFICATION_APP_IS_USING_BY_KID",
    alertText: "",
  },
  179: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-triangle text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_NEW_SOCIAL_MESSAGE",
    alertText: "",
  },
  177: {
    blockClassName:
      "alert alert-dismissible alert-danger fade show d-flex flex-wrap align-items-center gap-5 mb-0 h-100",
    iconClassName: "icon-info-triangle text-danger fs-5",
    alertName: "PARENT_NOTIFICATION_THREAT_DETECTED",
    alertText: "",
  },
};
